<table class="table table-striped" [attr.data-test]="`reportPortfolioRoadmapTable_${showProperty()}`">
  <thead>
    <th>{{ 'adres.address' | translate }}</th>
    @if (showProperty() === 'energyLabel') {
      <th class="text-end" [style.width]="80 / numberOfColumns() + '%'">
        {{ 'current' | translate }}
      </th>
    }
    @for (year of years(); track year) {
      <th class="text-end" [style.width]="75 / numberOfColumns() + '%'">{{ year }}</th>
    }
    @if (showProperty() === 'investment') {
      <th class="text-end" [style.width]="75 / numberOfColumns() + '%'">
        <strong>{{ 'roadmap.total.investment' | translate }}</strong>
      </th>
    }
  </thead>
  <tbody>
    @for (row of buildingsWithPlan(); track row.building.id) {
      <tr>
        <td>
          <div class="position-relative">
            <div class="d-flex">
              <cfp-street-view-image
                class="d-flex align-items-center"
                [buildingId]="row.building.id"
                [address]="row.building.displayAddress"
                [size]="'sm'"
                [showMonumentIcon]="row.building.monument"
              />
              <div
                class="ms-3 mb-0"
                [buildingAddress]="row.building.displayAddress"
                [countryCode]="row.building.countryCode"
              ></div>
            </div>

            <div class="badges">
              @if (row.building.ownershipStatus === OwnershipStatusDTO.PLANSTOSELLBEFORE2030) {
                <cfp-badge [badgeStyle]="'primary'" [classes]="'ms-2'">{{ translationKey('sell') | translate }}</cfp-badge>
              }
            </div>
          </div>
        </td>
        @if (showProperty() === 'energyLabel') {
          <td class="text-center">
            @if (row.energyLabels?.currentEnergyLabel) {
              <cfp-energy-label class="d-inline-block" [energyLabel]="row.energyLabels?.currentEnergyLabel" [size]="'sm'" />
            }
          </td>
        }
        @for (year of years(); track $index) {
          @switch (showProperty()) {
            @case ('energyLabel') {
              <td class="text-center">
                @if (row.roadmap.years[$index]?.improvedEnergyLabel) {
                  <cfp-energy-label
                    class="d-inline-block"
                    [energyLabel]="row.roadmap.years[$index].improvedEnergyLabel"
                    [size]="'sm'"
                  />
                }
              </td>
            }
            @case ('investment') {
              <td class="text-end">
                @if (row.roadmap.years[$index]?.investment) {
                  {{ row.roadmap.years[$index].investment | cfpCurrency: currencyCode() }}
                  @if (row.roadmap.years[$index].containsUserDefined) {
                    <cfp-icon [icon]="'pen-circle'" />
                  }
                }
              </td>
            }
          }
        }
        @if (showProperty() === 'investment') {
          <td class="text-end">
            @if (row.roadmap.totalInvestmentPlannedMeasures) {
              <strong>{{ row.roadmap.totalInvestmentPlannedMeasures | cfpCurrency: currencyCode() }}</strong>
            }
          </td>
        }
      </tr>
    }
  </tbody>
  @if (totalInvestments()) {
    <tfoot>
      <tr>
        <th>{{ 'roadmap.total.investment' | translate }}</th>
        @for (total of totalInvestments(); track $index) {
          <th class="text-end">
            @if (total.investment) {
              {{ total.investment | cfpCurrency: currencyCode() }}
            }
          </th>
        }
      </tr>
    </tfoot>
  }
</table>
